import React from 'react';
import { Container, Typography, Box, Paper } from '@mui/material';

const Boutique = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      <Paper sx={{ p: 4 }}>
        <Typography variant="h3" gutterBottom sx={{ color: '#c62828' }}>
          Boutique
        </Typography>
        <Box sx={{ textAlign: 'center', py: 8 }}>
          <Typography variant="h5" gutterBottom>
            Notre boutique sera bientôt disponible !
          </Typography>
          <Typography variant="body1" color="text.secondary" paragraph>
            Nous préparons une sélection de produits et équipements de secourisme 
            pour vous accompagner dans votre formation et votre pratique.
          </Typography>
          
        </Box>
      </Paper>
    </Container>
  );
};

export default Boutique;